import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteZahlungseingangCommandServiceModule } from '..';
import { DeleteZahlungseingangCommandComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    DeleteZahlungseingangCommandServiceModule
  ],
  declarations: [DeleteZahlungseingangCommandComponent],
  exports: [DeleteZahlungseingangCommandComponent],

})
export class DeleteZahlungseingangCommandComponentModule { }
